import { Grid } from "@material-ui/core";
import React from "react";
import { withFirebase } from "../Firebase";

const AlertTest = (props) => {
  const { firebase } = props;

  return <Grid container item xs={12} spacing={2}></Grid>;
};

export default withFirebase(AlertTest);
